import { jsx } from "react/jsx-runtime";
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f, f as focus } from "../../chunks/FocusRing.module-Bq14yC3x.js";
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from "../../chunks/mergeProps-CiRkc-tR.js";
import React__default from "react";
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
function $907718708eab68af$export$1a38b4ad7f578e1d(props) {
  let { children, focusClass, focusRingClass } = props;
  let { isFocused, isFocusVisible, focusProps } = $f7dceffc5ad7768b$export$4e328f61c538687f(props);
  let child = React__default.Children.only(children);
  return /* @__PURE__ */ React__default.cloneElement(child, $3ef42575df84b30b$export$9d1611c77c2fe928(child.props, {
    ...focusProps,
    className: clsx({
      [focusClass || ""]: isFocused,
      [focusRingClass || ""]: isFocusVisible
    })
  }));
}
const FocusRing = ({ children, focusClass, focusRingClass, ...rest }) => {
  return /* @__PURE__ */ jsx(
    $907718708eab68af$export$1a38b4ad7f578e1d,
    {
      focusClass: focusClass ? focusClass : focus.focusDefault,
      focusRingClass: focusRingClass ? focusRingClass : focus.focusRing,
      ...rest,
      children
    }
  );
};
export {
  FocusRing
};
